import styled from 'styled-components';

const StyledGoodPracticeListContainer = styled.div`
    padding-bottom: 25px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

export { StyledGoodPracticeListContainer };